import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchSettings = async () => {
        try {
            const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
            const response = await axios.get(`${API_URL}/settings`);
            if (response.data.success) {
                setSettings(response.data.data || {});
            }
        } catch (error) {
            console.error('Failed to fetch site settings:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    // Helper to safely get a setting
    const get = (key, defaultValue = '') => {
        if (settings && settings[key] !== undefined && settings[key] !== null) {
            return settings[key];
        }
        return defaultValue;
    };

    const getSocialLinks = () => {
        const raw = settings?.site_social_links;
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) && parsed.length > 0) return parsed;
            } catch (e) {
                // silent fail
            }
        }

        // Fallback to legacy
        const legacy = [];
        if (settings?.social_facebook) legacy.push({ platform: 'Facebook', icon: 'Facebook', url: settings.social_facebook });
        if (settings?.social_instagram) legacy.push({ platform: 'Instagram', icon: 'Instagram', url: settings.social_instagram });
        if (settings?.social_youtube) legacy.push({ platform: 'YouTube', icon: 'Youtube', url: settings.social_youtube });
        if (settings?.social_twitter) legacy.push({ platform: 'Twitter', icon: 'Twitter', url: settings.social_twitter });

        // Default if absolutely nothing
        if (legacy.length === 0) {
            return [
                { platform: 'Facebook', icon: 'Facebook', url: 'https://www.facebook.com/AdventoNepal' },
                { platform: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/adventonepal' },
                { platform: 'YouTube', icon: 'Youtube', url: 'https://www.youtube.com/@adventonepal9213' }
            ];
        }

        return legacy;
    };

    const value = {
        settings,
        loading,
        get,
        getSocialLinks,
        refreshSettings: fetchSettings
    };

    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    );
};
